export const USER_INFO = 'authenticated_user';